:host {
  display: block;
  font-size: 12px;
  color: var(--theme-primary-text);

  --aha-field--label-width: 160px;
  --aha-field--gap: var(--spacer-2);
  --aha-field-flex-gap: var(--spacer-6);
  --aha-field--font-size: 12px;
  --aha-field--label-color: var(--theme-primary-text);
  --aha-field--input-background-color: var(--theme-primary-background);
  --aha-field--input-border-color: var(--theme-primary-border);
  --aha-field--input-border-width: 1px;
  --aha-field--input-placeholder-color: var(--theme-tertiary-text);
  --aha-field--input-focus-border-color: var(--theme-link-text);
  --aha-field--input-focus-background-color: var(--theme-primary-background);

  --aha-field--error-background-color: var(--theme-primary-background);
  --aha-field--error-color: var(--theme-button-danger);
  --aha-field--input-vertical-padding: 6px;
  --aha-field--input-horizontal-padding: 8px;
  --aha-field--input-padding: var(--aha-field--input-vertical-padding)
    var(--aha-field--input-horizontal-padding);

  --aha-field--label-inner--left-padding: var(--spacer-3);
  --aha-field--label--font-weight: 500;
  --aha-field--input--right-padding: 0px;
  /* Needs to account for the fact that the padding of an input is really the padding + the border width. */
  --aha-field--label-vertical-padding: calc(
    var(--aha-field--input-vertical-padding) + var(--aha-field--input-border-width)
  );
  --aha-field--additional-min-height: calc(var(--aha-field--font-size) + var(--aha-field--gap));
}
:host,
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}

:host [hidden] {
  display: none !important;
}

/* Hide slotted element if it is empty. Prevents extra margin from appearing.
 * NOTE: Only hides the element if it is completely empty (including whitespace).
 */
:host slot::slotted(*:not(input):not(textarea):empty) {
  display: none;
}

:host .label {
  font-size: var(--aha-field--font-size);
  font-weight: var(--aha-field--label--font-weight);
  margin: 0;
}

.aha-field__label {
  cursor: inherit;
}

/* Based on styles from <aha-flex> component. */
:host .aha-field__column {
  display: flex;
  flex-direction: row;
}

:host([error]) .aha-field__error {
  color: var(--aha-field--error-color);
}

:host([error]) input:not([type='checkbox']):not([type='radio']),
:host([error]) textarea {
  border-color: var(--aha-field--error-color);
}

:host([error]) input:not([type='checkbox']):not([type='radio']):focus,
:host([error]) textarea:focus {
  background-color: var(--aha-field--error-background-color);
}

:host .aha-field__required-container {
  display: inline-flex;
}
:host .aha-field__required {
  color: var(--aha-field--error-color);
  cursor: pointer;
}
:host .aha-field__required::before {
  content: '*';
}

:host .additional {
  display: flex;
  flex-direction: column;
  /* `min-height` is set so that fields don't jump vertically when error messages are added dynamically.*/
  min-height: var(--aha-field--additional-min-height);
  margin-bottom: var(--aha-field--gap);
}

:host .additional--no-reserved-height {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  --aha-field--additional-min-height: 0;
}

:host .additional slot::slotted(*),
:host .additional slot * {
  margin-top: calc(var(--aha-field--gap) / 2);
}

:host .additional slot[name='error']::slotted(*),
:host .additional slot[name='error'] * {
  color: var(--aha-field--error-color);
}

:host .additional slot[name='help']::slotted(*),
:host .additional slot[name='help'] * {
  color: var(--theme-tertiary-text);
}

slot[name='label'] {
  cursor: pointer;
}
:host .label .hint {
  margin-left: 0.2ch;
}

/* Horizontal field layout */
:host([layout='horizontal']) {
  width: 100%;
  --aha-field--font-size: 14px;
}
:host([layout='horizontal']) .aha-field__label {
  width: 100%;
}
:host([layout='horizontal']) .aha-field__column {
  gap: var(--aha-field-flex-gap);
}
:host([layout='horizontal']) .label {
  padding-top: var(--aha-field--label-vertical-padding);
  padding-bottom: var(--aha-field--label-vertical-padding);
  text-align: right;
}
:host([layout='horizontal']) .label-inner {
  display: flex;
  width: var(--aha-field--label-width);
  justify-content: end;
}
:host([layout='horizontal']) .aha-field__column {
  align-items: stretch;
}
:host([layout='horizontal']) .aha-field__input {
  flex: 1 1 100%;
  max-width: calc(
    100% - var(--aha-field-flex-gap) - var(--aha-field--label-width) -
      var(--aha-field--input--right-padding)
  );
}

/* Horizontal in-line field layout */
:host([layout='horizontal'][inline-form-field]) {
  --aha-field--input--right-padding: 40px;
  --aha-field--font-size: 12px;
  --aha-field--label--font-weight: 400;
  --aha-field--label-width: 80px;
}

:host([layout='horizontal'][inline-form-field]) .label {
  padding-left: var(--aha-field--label-inner--left-padding);
  text-align: left;
}

:host([layout='horizontal'][inline-form-field]) .label-inner {
  justify-content: start;
}

/* Vertical field layout */
:host([layout='vertical']) .label {
  margin-bottom: calc(var(--aha-field--gap) / 2);
}
:host([layout='vertical']) .label-inner {
  display: inline-flex;
}

:host([layout='vertical']) .aha-field__column {
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  align-content: flex-start;
}
